import { AnimatePresence, motion } from "framer-motion";
import { useFormCtx } from "../FormContext";
const animationConfiguration = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};
const AniamtedFadeBlock = ({ children, delay = 0.3 }) => {
  const { currentBtnPageIndex } = useFormCtx();

  return (
    <motion.div key={currentBtnPageIndex} variants={animationConfiguration} initial="initial" animate="animate" transition={{ delay: delay, duration: 0.3 }}>
      {children}
    </motion.div>
  );
};
export default AniamtedFadeBlock;
